module.exports = __webpack_public_path__ + "img/mySignatureEle.ad6bec5f.svg";